import React from 'react';
import CircularText from '../components/CircularText';

export default function About() {
  const sectionClasses = "max-w-[85rem] w-full px-4 md:px-24 mx-auto font-['Montserrat',sans-serif]";

  return (
    <div>
      <div className="bg-white pb-20 md:pb-36 pt-48 md:pt-64 mb-20 md:mb-36">

        {/* Section 1: Hero Heading (The only H1 on the page) */}
        <section className={sectionClasses}>
          <h1 className="text-4xl sm:text-5xl md:text-8xl leading-tight font-medium [letter-spacing:-1px] md:[letter-spacing:-2px] capitalize">
            Crafting the future <br  className='hidden md:block'/> of digitial interaction.
          </h1>
          <hr className="my-8 h-px border-0 bg-gray-300 mt-12 md:mt-24 mb-10 md:mb-16" />
        </section>

        {/* Section 2: Intro & Profile Image */}
        <section className={sectionClasses}>
          <div className="flex flex-col md:flex-row gap-12 md:gap-8 text-black mb-20 md:mb-36">
            <div className="w-full md:w-1/2">
              <p className='w-full md:w-3/4 text-justify mb-5 md:text-xl'>
                I bridge the gap between what’s possible and what’s beautiful. I use technology as my canvas to tell stories that users can touch, move, and change.
              </p>
              <p className='w-full md:w-2/3 text-justify text-gray-500'>Always exploring..</p>
            </div>
            <div className="w-full md:w-2/2">
              <img 
                src="/Images/profile.webp" 
                alt="Profile" 
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </section>

        {/* Section 3: Services (REVERTED TO 110rem for Desktop) */}
        <section className="text-black max-w-440 w-full px-4 md:px-24 mx-auto font-['Montserrat',sans-serif]">
          {/* UPDATED: Changed H1 to H2 for correct hierarchy */}
          <h2 className="text-3xl md:text-5xl mt-8 md:mt-16 mb-8 md:mb-10 leading-tight font-medium ">
            What excites me?
          </h2>
          
          <div className="flex flex-col md:flex-row gap-12 md:gap-24 text-black">
            {/* Service 01 */}
            <div className="w-full md:w-1/3 md:[word-spacing:2px] ">
                <p className="hidden md:block text-zinc-500">01</p>
                <hr className="mt-4 mb-6 md:mb-10 h-px border-0 bg-gray-300" />
                {/* UPDATED: Changed H1 to H3 */}
                <h3 className="text-3xl md:text-4xl mb-4 md:mb-5">Design</h3>
                {/* Added leading-relaxed for more vertical gap. For even more gap, use leading-loose */}
                <p className='text-sm md:text-base leading-relaxed'>
                  Creating innovative designs with intend to solve user needs. 
                  I create visual systems that translate complex ideas into clear, 
                  meaningingsful experiences. 
                </p>
            </div>

            {/* Service 02 */}
            <div className="w-full md:w-1/3">
                <p className="hidden md:block text-zinc-500">02</p>
                <hr className="mt-4 mb-6 md:mb-10 h-px border-0 bg-gray-300" />
                {/* UPDATED: Changed H1 to H3 */}
                <h3 className="text-3xl md:text-4xl mb-4 md:mb-5">Development</h3>
                <p className='text-sm md:text-base leading-relaxed'>
                  Writing logics to achieve clean aesthetics. Passionate to code the intersection of structure and style.
                </p>
            </div>

            {/* Service 03 */}
            <div className="w-full md:w-1/3">
                <p className="hidden md:block text-zinc-500">03</p>
                <hr className="mt-4 mb-6 md:mb-10 h-px border-0 bg-gray-300" />
                {/* UPDATED: Changed H1 to H3 */}
                <h3 className="text-3xl md:text-4xl mb-4 md:mb-5">Experiments</h3>
                <p className='text-sm md:text-base leading-relaxed'>
                  Dismantling  my toys just to find the magic inside. Today, i use the same curiosity to experiment to make something entirely new. 
                </p>
            </div>
          </div>
        </section>
      </div>

      {/* Section 4: Bio Footer */}
      <div className={`${sectionClasses} flex mb-20 md:mb-36 justify-center items-center flex-col md:flex-row gap-12 md:gap-24 text-black`}>
        <div className="w-full md:w-1/2 md:px-0 order-1 md:order-2">
          {/* UPDATED: Changed H1 to H2 */}
          <h2 className='text-3xl md:text-4xl font-medium mb-6'>Deepayu Ninama</h2>
          <p className='text-base md:text-lg leading-relaxed'>
            Curiosity is what drives me. I love exploring the world through travel, 
            photography, and cinematography to find new ways of seeing things. Whether 
            I’m leading a creative team or staying active on the football and badminton courts, 
            I thrive in roles that require both vision and action. I am a lifelong explorer and a
             natural leader who enjoys turning big ideas into reality.
          </p>
        </div>

        <div className="w-full md:w-1/2 order-2 md:order-1">
          <img 
            src="/Images/profile1.webp" 
            alt="Profile" 
            className="w-full h-auto hover:grayscale-0 transition-all duration-500"
          />
        </div>
      </div>
    </div>
  );
}